import Data from '@/modules/data';

export default (data) => (data ? Data.format(data) : '');
